import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class CsvExportService {
  constructor() {}

  exportToCsv(filename: string, data: any[], columns?: string[]): void {
    const csvContent = this.convertToCsv(data, columns);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, filename);
  }

  private convertToCsv(data: any[], columns?: string[]): string {
    if (!data || data.length === 0) {
      return '';
    }

    const headers = columns || Object.keys(data[0]);
    const headers_to_render = [
      'Column Name',
      'Snowflake Description',
      'User Instruction',
      'AI Generated Description',
      'AI Generated Classification',
      'AI Model Reasoning',
      'Confidence Score',
    ];
    let csv = headers_to_render.join(',') + '\n';

    data.forEach((row) => {
      const rowValues = headers.map((header) => {
        const value = row[header];
        // Handle values that might contain commas or newlines
        return `"${String(value).replace(/"/g, '""')}"`;
      });
      csv += rowValues.join(',') + '\n';
    });

    return csv;
  }
}
